interface Props {
  quote: string;
  quoteAuthor?: string;
  authorCredentials?: string;
  alignment: string;
}

const Quote = ({ quote, quoteAuthor, authorCredentials }: Props) => {
  return (
    <div className="tw-grid tw-gap-y-3">
      <p className="tra-text-web-heading-6 tw-text-center">&ldquo;{quote}&rdquo;</p>
      {quoteAuthor && (
        <p className="tra-text-web-sub-2 tw-text-center">
          - {quoteAuthor}
          {authorCredentials && `, ${authorCredentials}`}
        </p>
      )}
    </div>
  );
};

export default Quote;
